import { SUPPORT_FEATURE } from "api/ApiPath";
import client from "api/client";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { IOfficialDispatchRepository } from "features/officialDispatch/domain/repositories/IOfficialDispatchRepository";
import { injectable } from "tsyringe";
import { OfficialDispatchRequestModel } from "./model/OfficialDispatchRequestModel";
import { OfficialDispatchResponseModel } from "./model/OfficialDispatchResponseModel";
import { CreateFileRequestEntity } from "../domain/entities/CreateFileRequestEntity";
import { OfficialDispatchResponseEntity } from "../domain/entities/OfficialDispatchResponseEntity";
import { DeleteFileRequestModel } from "./model/DeleteFileRequestModel";

@injectable()
export class OfficialDispatchImpl implements IOfficialDispatchRepository {
  async getOfficialDispatches(
    params: OfficialDispatchRequestModel
  ): Promise<ListBaseApiResponseModel<OfficialDispatchResponseModel>> {
    return await client.get(SUPPORT_FEATURE.OFFICIAL_DISPATCH, params);
  }

  async createFile(
    params: CreateFileRequestEntity
  ): Promise<BaseApiResponseModel<OfficialDispatchResponseEntity>> {
    const formData = new FormData();
    if (params?.service) formData.append("service", params?.service);
    if (params?.type !== undefined) formData.append("type", params?.type?.toString());
    if (params?.folderPath) formData.append("folderPath", params?.folderPath);
    if (params?.isPrivate !== undefined) formData.append("isPrivate", params?.isPrivate?.toString());
    if (params?.fileField) formData.append("fileField", params?.fileField);
    if (params?.order !== undefined) formData.append("order", params?.order?.toString());
    if (params?.file) formData.append("file", params?.file, params?.file?.name);

    return await client.post(SUPPORT_FEATURE.UPLOAD_FILE, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  async deleteFile(
    params: DeleteFileRequestModel
  ): Promise<BaseApiResponseModel<unknown>> {
    return await client.delete(SUPPORT_FEATURE.DELETE_FILE, params);
  }
}

